import { render, staticRenderFns } from "./SelectColumns.vue?vue&type=template&id=c0362320"
import script from "./SelectColumns.vue?vue&type=script&lang=js"
export * from "./SelectColumns.vue?vue&type=script&lang=js"
import style0 from "./SelectColumns.vue?vue&type=style&index=0&id=c0362320&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports